<template>
  <nuttrema-layout-content theme="dc-logo">
    <router-view slot="overflow"></router-view>

    <my-preferences-standard-header
       slot="header"
      :meta="meta"
      :edit.sync="edit"
      :PersonalProfile="PersonalProfile">
      <div slot="edit" class="content-header-item">
        <permissions-control-wrapper
           action="label.edit"
          :required-general="$PERMISSIONS_GENERAL.EDIT_BIOGRAPHY"
          :permissions="_get(PersonalProfile, 'meta.permissions')">
          <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
          <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
        </permissions-control-wrapper>
      </div>
    </my-preferences-standard-header>

    <template slot="central">
      <nuttrema-loader v-if="PersonalBiography.fetching"></nuttrema-loader>
      <nuttrema-empty-result
        v-else-if="isEmpty"
        class="with-logo"
        predefined-set="landscape">
      </nuttrema-empty-result>
      <my-preferences-professional-biography
         v-else
        :meta="meta"
        :edit="edit"
        :PersonalProfile="PersonalProfile"
        :PersonalBiography="PersonalBiography"
        @remove="onRemoveEvent">
      </my-preferences-professional-biography>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';
import { get } from 'lodash';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import MyPreferencesStandardHeader from 'components/pages/professional/settings/my-preferences/shared/cmpt-my-preferences-standard-header';

import MyPreferencesProfessionalBiography from './cmpt-my-preferences-professional-biography';

export default {
  name: 'page-my-preferences-professional-biography',
  mixins: [PageProps],
  components: {
    NuttremaLayoutContent,
    MyPreferencesStandardHeader,
    MyPreferencesProfessionalBiography,
  },
  data() {
    return {
      edit: false,
    };
  },
  methods: {
    ...mapActions([
      'RemoveProfessionalExperience',
      'RemovePersonalEducation',
    ]),
    onRemoveEvent(type, id) {
      const action = type === 'experience' ? this.RemoveProfessionalExperience : this.RemovePersonalEducation;
      const label = type === 'experience' ? 'label.professional_experience' : 'label.education';
      return action({ id })
        .then(() => {
          this.successNotification({ label, message: 'message.default_success_delete_message' });
          this.onSuccessEvent();
        }).catch(() => {
          this.errorNotification();
        });
    },
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    PersonalBiography() {
      return this.$store.getters.PersonalBiography;
    },
    isEmpty() {
      const experience = get(this.PersonalBiography, 'data.PersonEducation', []);
      const education = get(this.PersonalBiography, 'data.PersonExperience', []);
      const interests = get(this.PersonalProfile, 'data.PersonData.personal_biography_interests', false);
      console.log('ttt', experience.length > 0, education.length > 0, interests);
      return experience.length === 0 && education.length === 0 && !interests;
    },
  },
  created() {
    this.$store.dispatch('GetPersonalBiography');
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalBiography');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/professional-biography/page-my-preferences-professional-biography.vue